/**
 * API client for Aquarimate maintenance activities endpoints
 */

import type { MaintenanceActivityResponse } from '@/types/maintenance';
import { buildApiUrl } from './config';
import { apiClient } from './client';
export interface MaintenanceActivityFilters {
  start_date?: string; // YYYY-MM-DD
  end_date?: string; // YYYY-MM-DD
  task_types?: number[]; // [0, 1, 4] = Maintenance, Dosing, Daily Task
  task_titles?: string[]; // Specific task titles to filter
  performed_only?: boolean; // Only return completed activities
}

export const api = {
  /**
   * Fetch maintenance activities with optional filtering
   */
  async getMaintenanceActivities(
    tankId: string,
    filters?: MaintenanceActivityFilters
  ): Promise<MaintenanceActivityResponse> {
    const url = new URL(buildApiUrl(`/api/tanks/${tankId}/maintenance/activities`), window.location.origin);

    // Add query parameters
    if (filters?.start_date) {
      url.searchParams.append('start_date', filters.start_date);
    }
    if (filters?.end_date) {
      url.searchParams.append('end_date', filters.end_date);
    }
    if (filters?.task_types && filters.task_types.length > 0) {
      url.searchParams.append('task_types', filters.task_types.join(','));
    }
    if (filters?.task_titles && filters.task_titles.length > 0) {
      url.searchParams.append('task_titles', filters.task_titles.join(','));
    }
    if (filters?.performed_only !== undefined) {
      url.searchParams.append('performed_only', String(filters.performed_only));
    }

    const response = await apiClient(url.toString(), {
      method: 'GET',
      headers: {
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: response.statusText }));
      throw new Error(error.detail || `HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  },
};
